import {Component} from '@angular/core';

import {BaMsgCenterService} from './baMsgCenter.service';

@Component({
  selector: 'ba-msg-center',
  // providers: [BaMsgCenterService],
  styleUrls: ['./baMsgCenter.scss'],
  templateUrl: './baMsgCenter.html'
})
export class BaMsgCenter {

  public notifications:Array<Object>;
  public messages:Array<Object>;

  constructor(private _baMsgCenterService:BaMsgCenterService) {
    // this.notifications = this._baMsgCenterService.getNotifications();
    this._baMsgCenterService.notifications.subscribe(data=>{
      this.notifications = data;
    })
    
    this.messages = this._baMsgCenterService.getMessages();
  }

}



// WEBPACK FOOTER //
// ./src/app/theme/components/baMsgCenter/baMsgCenter.component.ts